import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import logoPoolTonight from "../../assets/logo-pooltonight.png";
import { useAppAuthState } from "../../hooks/useAppAuthState";
import "./SplashScreen.scss";

function SplashScreen() {
  const { isLoggedIn } = useAppAuthState();
  const navigate = useNavigate();
  const showDownloadButtons = false;

  const handleHeaderClick = useCallback(() => {
    if (isLoggedIn) {
      navigate("/map");
    } else {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  return (
    <div className="splash-screen">
      <header className="splash-header" onClick={handleHeaderClick}>
        <div className="splash-logo-container">
          <img
            src={logoPoolTonight}
            alt="Pool Tonight Logo"
            className="splash-logo"
          />
        </div>
        <h1>Pool Tonight</h1>
      </header>
      {showDownloadButtons && (
        <div className="cta-buttons">
          <a href="#android-download">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Android_robot.svg/174px-Android_robot.svg.png"
              alt="Download for Android"
              title="Download for Android"
              className="cta-image"
            />
          </a>
          <a href="#ios-download">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Apple_logo_black.svg/170px-Apple_logo_black.svg.png"
              alt="Download for iOS"
              title="Download for iOS"
              className="cta-image"
            />
          </a>
        </div>
      )}
    </div>
  );
}

export default SplashScreen;
